import { useSelector } from "react-redux";
import { Image, Text, Flex, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import NavigationBar from "src/components/NavigationBar";
import { H3 } from "src/atoms/typography";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { usePurchaseContext } from "src/modules/purchase/PurchaseContext";
import getImageSrc from "src/utils/getImageSrc";
import { getAppValue } from "src/utils/environment";

export default function NoCommands({ onClose, onBack, openEditor }) {
  const { t } = useTranslation();
  const purchase = usePurchaseContext();
  const isFreeVersion = useSelector(isFreemium);

  const imageSource = getAppValue({
    barkio: "empty-commands.svg",
    bibino: "empty.svg"
  });
  return (
    <Flex flexDirection="column" alignItems="center" height="100%">
      <NavigationBar
        headingKey="command.commands"
        onBack={onBack}
        onClose={onClose}
      />
      <Flex
        width="320px"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        pb="24px"
        flex="1 1 auto"
      >
        <Image width="176px" src={getImageSrc(imageSource)} />
        <H3 textAlign="center" color="highEmphasis" mt="24px">
          {t("command.noCommands.heading")}
        </H3>
        <Text
          textAlign="center"
          mt="8px"
          color="mediumEmphasis"
          fontSize="14px"
          letterSpacing={"-0.1px"}
        >
          {t("command.noCommands.text")}
        </Text>
      </Flex>
      <Flex flex="0 0 auto" mb="24px" justifyContent="center">
        <Button
          variant="containedPrimary"
          onClick={
            isFreeVersion
              ? () => purchase.open({ content: "playAndRecord" })
              : openEditor
          }
          minWidth="196px"
        >
          {t("command.openCommandsEditor")}
        </Button>
      </Flex>
    </Flex>
  );
}
